import { render } from "./ImportCustomers.vue?vue&type=template&id=56d68381&scoped=true"
import script from "./ImportCustomers.vue?vue&type=script&lang=ts"
export * from "./ImportCustomers.vue?vue&type=script&lang=ts"

import "./ImportCustomers.vue?vue&type=style&index=0&id=56d68381&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-56d68381"

export default script